import { useEffect, useState } from "react";
import moment from "moment";
import { faFileContract } from "@fortawesome/free-solid-svg-icons";
import {
    Content,
    PaginationTableFilter,
    PaginationTable,
    ButtonLink,
    Row,
    Col,
    FloatSelect,
    Button,
} from "@webtypen/react-components";
import { Page } from "../../components/Page";

export const ContractsOverviewCustomer = () => {
    const [filter, setFilter] = useState({});
    const [isResetting, setIsResetting] = useState(true);
    const [type, setType] = useState("");

    const changeType = (e) => {
        const newValue = e.target.value;
        setIsResetting(true);

        setTimeout(() => {
            setIsResetting(false);
            setType(newValue);
            localStorage.setItem("contracts_list_type", newValue);
        }, 500);
    };

    useEffect(() => {
        const lastType = localStorage.getItem("contracts_list_type");
        setType(lastType && lastType.trim() !== "" ? lastType.trim() : "");
        setIsResetting(false);
    }, []);

    const today = moment().format("YYYY-MM-DD");
    return (
        <Page icon={faFileContract} title="Aufträge">
            <Content>
                {isResetting ? null : (
                    <>
                        <PaginationTableFilter
                            definition={{
                                number: { type: "text", label: "Nummer" },
                                customer_contract_number: { type: "text", label: "Auftragsnummer Kunde" },
                            }}
                            filter={filter}
                            setFilter={setFilter}
                        />
                        <PaginationTable
                            url="/api/contracts/list"
                            payload={{ filter: filter, type: type }}
                            tableAttributes={{ className: "valign-middle" }}
                            columns={[
                                { label: "Starbatys-Nr", attributes: { style: { width: 100 } } },
                                { label: "Auftragsnr", attributes: { style: { width: 150 } } },
                                { label: "Ort" },
                                { label: "Datum", attributes: { style: { width: 120 } } },
                                { label: "Optionen", attributes: { style: { width: 120 }, className: "text-right" } },
                            ]}
                            render={(row, i) => (
                                <tr key={i}>
                                    <td style={{ opacity: today > row.date ? 0.5 : 1 }}>
                                        {row.number ? row.number : "-"}
                                    </td>
                                    <td style={{ opacity: today > row.date ? 0.5 : 1 }}>
                                        {row.customer_contract_number ? row.customer_contract_number : "-"}
                                    </td>
                                    <td style={{ opacity: today > row.date ? 0.5 : 1 }}>
                                        {row.address_city && row.address_city ? row.address_city : "-"}
                                    </td>
                                    <td style={{ opacity: today > row.date ? 0.5 : 1 }}>
                                        {row.date ? moment(row.date).format("DD.MM.YYYY") : "-"}
                                    </td>
                                    <td className="text-right">
                                        <ButtonLink to={"/contracts/" + row._id + "/details"} sm>
                                            Ansehen
                                        </ButtonLink>
                                    </td>
                                </tr>
                            )}
                        />
                    </>
                )}
            </Content>
        </Page>
    );
};
